import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_PROVIDER_COMMISSION_VAT, propTypes } from '../../util/types';
import { vatFromTransaction, rateLabel } from '../../util/vat';

import css from './BookingBreakdown.css';

// VAT on the Freedomly fee, charged to the provider on the Stripe path
// when Freedomly's platform fee itself carries VAT (spec §3).
const LineItemProviderCommissionVatMaybe = props => {
  const { transaction, isProvider, intl } = props;
  if (!isProvider) return null;
  const item = transaction.attributes.lineItems.find(
    li => li.code === LINE_ITEM_PROVIDER_COMMISSION_VAT && !li.reversal
  );
  if (!item) return null;
  const { platformFee } = vatFromTransaction(transaction);
  const label = rateLabel(
    { rate: Number(item.percentage) / 100, label: (platformFee && platformFee.label) || 'VAT' },
    intl.locale
  );
  return (
    <div className={css.commissionLineItem}>
      <span className={css.boldItemLabel}>
        <FormattedMessage id="BookingBreakdown.commissionVat" values={{ rateLabel: label }} />
      </span>
      <span className={css.boldItemValue}>{formatMoney(intl, item.lineTotal)}</span>
    </div>
  );
};

LineItemProviderCommissionVatMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};
export default LineItemProviderCommissionVatMaybe;
